import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Menu, Input, Icon } from 'semantic-ui-react';
import { openCustomerModal, exportCustomers, exportCreditReport } from '../actions';


class CustomerMenu extends Component {
    state = {
        activeItem: ''
    }

    handleFilterClick(e) {
        console.log('Filter clicked');
    }

    handleAddCustomer = (e) => {
        console.log('Add Customer clicked');
        this.props.openCustomerModal(true);
    }

    handleExportClick = (e) => this.props.exportCustomers(true);

    handleExportCreditReportClick = (e) => this.props.exportCreditReport(true);

    render() {
        const { activeItem } = this.state;
        return (
            <Menu fixed='left' vertical style={{ marginTop: '5em', marginLeft: '0em' }} >
                {/* <Menu.Item>
                    <Input placeholder='Search...' />
                </Menu.Item> */}
                <Menu.Item name='filter' onClick={this.handleFilterClick.bind(this)} disabled>
                    <Icon name='filter' />
                    Filter
                </Menu.Item>
                <Menu.Item name='add' onClick={this.handleAddCustomer.bind(this)}>
                    <Icon name='add user' />
                    Add Customer
                </Menu.Item>
                    <Menu.Item name='credit'onClick={this.handleExportCreditReportClick.bind(this)}>
                        <Icon name='sticky note outline' />
                        Export Credit Report
            </Menu.Item>
                <Menu.Item name='messages' active={activeItem === 'messages'} onClick={this.handleExportClick.bind(this)}>
                    <Icon name='download' />
                    Export Customer List
                </Menu.Item>
            </Menu>
        )
    }
}

const mapStateToProps = ({ customer }) => {
    return { customer }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        openCustomerModal: openCustomerModal,
        exportCustomers: exportCustomers,
        exportCreditReport : exportCreditReport,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(CustomerMenu);
